import React, { Component } from 'react'
import { connect } from 'react-redux'

import 'normalize.css/normalize.css'
import '../global.css'

import { logout } from '../redux/auth'
import { toggleNav, closeNav } from '../redux/nav'
import { updateUser } from '../redux/users'
import { isAnonymous, userHasPerm } from '../utils/auth'
import Header from '../components/Header'
import Navigation from '../components/Navigation'
import Banners from '../components/Banners'

class App extends Component {
  render () {
    const { children, location, params, nav, user, toggleNav, closeNav, logout, anonymousUser, updateUser } = this.props
    return (
      <div>
        <Header
          path={location.pathname}
          title={children.props.route.title}
          toggleNav={toggleNav}
          anonymousUser={anonymousUser}
          previousPath={nav.previousPath}
          canSearch={this.props.canSearch}
          params={params}
        />
        {children}
        <Banners />
        <Navigation
          open={nav.open}
          closeNav={closeNav}
          logout={logout}
          anonymousUser={anonymousUser}
          user={user}
          updateUser={updateUser}
        />
      </div>
    )
  }
}

const mapStateToProps = ({ nav, auth }) => ({
  nav,
  user: auth.user,
  anonymousUser: isAnonymous(auth.user),
  canSearch: userHasPerm(auth.user, 'search_and_save')
})

const mapDispatchToProps = {
  toggleNav,
  closeNav,
  logout,
  updateUser
}

export default connect(mapStateToProps, mapDispatchToProps)(App)



// WEBPACK FOOTER //
// ./src/pages/App.js